// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2390":"2a46b343","3704":"d2acb277","4422":"ee6032ac","5043":"1c0cba8c","5569":"71bcc6ba","7950":"4830e05b","9788":"e3f5d230"}[chunkId] + ".chunk.js";
};